import createModel, { prop } from './lib/create_model';

const AgentExperienceConfig = createModel({
  modelName: 'AgentExperienceConfig',

  properties: {
    allowExternalName: prop(Boolean).default(true),
  },

  statics: {
    create() {
      return new this();
    },
  },
});

export default AgentExperienceConfig;
